import { configureStore } from 'src/redux/store'
import * as storage from 'src/helpers/storage'
import { STORAGE_USER_DATA, URL_LOGOUT } from 'src/constants'

const storageUserName = STORAGE_USER_DATA
let userInfo = storage.getItem(storageUserName)

configureStore().subscribe((newState) => {
  userInfo = storage.getItem(storageUserName)
})

export const headers = {
  'Content-Type': 'application/json; charset=utf-8',
  Accept: 'application/json',
}

export const responseTransform = (response) => {
  const { status } = response

  if (status === 401) {
    console.log('nao autorizado')
    window.location.href = URL_LOGOUT
  }
}

export const interceptorsRequest = async (request) => {
  userInfo = storage.getItem(storageUserName)

  if (userInfo && userInfo.data) {
    request.headers['Authorization'] = `bearer ${userInfo.data.AccessToken}`

    if (userInfo.data.Token) {
      request.params = {
        ...request.params,
        token: userInfo.data.Token,
      }
    } else {
      request.params = {
        ...request.params,
        token: 0,
      }
    }
  } else {
    request.params = {
      ...request.params,
      token: 0,
    }
  }

  return request
}
